<template>
  <div
    class="cursor-pointer flex gap-4 items-start p-1.5 border rounded-lg drop-shadow-md"
    :class="getToastClass()"
    role="status"
    aria-live="polite"
    data-testid="toast-message"
    @mouseenter="mouseEnter"
    @mouseleave="mouseLeave"
    @click="closeMessage"
  >
    <div class="flex gap-4 items-center p-1.5 text-md flex-1" :class="getContainerClass()">
      <MessageIcon :msg="msg" size="base" />
      <Content :message="msg.message" :title="msg.options?.title" :actions="msg.options?.actions" />
    </div>
    <button>
      <Icon name="toast.close" size="base" iconClass="bg-orange-700 dark:bg-orange-500" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { ToastMessage, useToastStore } from '@/store/useToastStore';
import Content from './Content.vue';
import MessageIcon from './MessageIcon.vue';
import { Icon } from '@/storybook/icon';

const toastClass = {
  success: 'bg-white dark:bg-zinc-700 border-slate-300 dark:border-zinc-900',
  info: 'bg-white dark:bg-zinc-700 border-slate-300 dark:border-zinc-900',
  warn: 'bg-orange-100 dark:bg-orange-700 border-orange-300 dark:border-orange-900',
  error: 'bg-red-100 dark:bg-red-700 border-red-300 dark:border-red-900',
};

const containerClass = {
  success: 'text-slate-700 dark:text-zinc-300',
  info: 'text-slate-700 dark:text-zinc-300',
  warn: 'text-orange-700 dark:text-orange-300',
  error: 'text-red-700 dark:text-red-300',
};

const props = defineProps<{
  msg: ToastMessage;
}>();

const mouseEnter = () => props.msg.timer && props.msg.timer.pause();
const mouseLeave = () => props.msg.timer && props.msg.timer.resume();

const store = useToastStore();
const closeMessage = () => store.removeToast(props.msg);
const getToastClass = () => toastClass[props.msg.type];
const getContainerClass = () => containerClass[props.msg.type];
</script>
